import { createContext } from "react";
import type { BusinessLocation } from "../types/businessLocationTypes";
import type { Business } from "../types/businessTypes";

export interface BusinessContextType {
  business: Business | undefined;
  location: BusinessLocation | undefined;
  businessId: string | undefined;
  locationId: string | undefined;
  businesses: Business[];
  locations: BusinessLocation[];
  loading: boolean;
  workspaceReady: boolean;
  switchBusiness: (businessId: string) => void;
  switchLocation: (locationId: string) => void;
}

export const BusinessContext = createContext<BusinessContextType | undefined>(
  undefined
);
